import { render } from '@testing-library/react';
import React, { useState, useEffect } from 'react';
import * as constants from '../../constants/constants';
import MatchQuestion from '../MatchQuestion';
import CrazyArrow from '../CrazyArrow';
import DirectionArrow from '../DirectionArrow';
import PointAndMove from '../PointAndMove';
import './Game.scss';
import { getColorName } from '../../utils/utils';

const Game = (props) => {
    const [startTime, setStartTime] = useState(null);
    const questionSpecs = props?.question?.specs;
    const [highlightResponse, setHighlightResponse] = useState(null);

    const qstyle = {
        fontSize: "30px",
        textTransform: "capitalize",
        fontStyle: "italic",
        fontWeight: "bold",
        marginTop: "10px",
        marginBottom: "10px",
    }

    const renderQuestion = (type) => {
        switch (type) {
            case constants.MATCH:
                return <span style={{ visibility: props.currentQuesNo > 0 || props.loopOnce ? "hidden" : "visible" }}>{`Does the ${questionSpecs.match} of the ${questionSpecs.with} word match the color of the ${questionSpecs.with == "left" ? "right" : "left"} word?`}</span>
            case constants.CRAZY_ARROWS:
                return `Does the ${questionSpecs.match} of the ${questionSpecs.with} arrow match the text? `
            case constants.TRIPLE_ARROWS:
                return `If the arrows are ${getColorName(questionSpecs.arrowColors)} tap the direction that they are ${questionSpecs.type} pointing `;
            case constants.PONT_OR_MOVE:
                return <React.Fragment>{`What direction are the arrows`}<h5 style={qstyle}>{questionSpecs.type} ?</h5></React.Fragment>;
            default:
                return '';
        }
    }

    const renderQuestionVisual = (type) => {
        switch (type) {
            case constants.MATCH:
                return <MatchQuestion specs={questionSpecs} />
            case constants.CRAZY_ARROWS:
                return <CrazyArrow specs={questionSpecs} />
            case constants.TRIPLE_ARROWS:
                return <DirectionArrow specs={questionSpecs} />
            case constants.PONT_OR_MOVE:
                return <PointAndMove specs={questionSpecs} />
            default:
                return '';
        }
    }

    useEffect(() => {
        setStartTime(props.timer ? props.timer : 45);
    }, [props.question]);
    return (
        <div className="Game">
            <div className={`visual ${highlightResponse ? (highlightResponse == "correct" ? 'correct-answer' : 'wrong-answer') : ''}`}>
                {renderQuestionVisual(props?.question?.type)}
            </div>
            <div className="question">
                {renderQuestion(props?.question?.type)}
            </div>
            {
                props.question?.specs?.options.map((option, index) => (
                    <button disabled={highlightResponse} className={`questionOptions style-${index} ${props?.question?.type == constants.TRIPLE_ARROWS || props?.question?.type == constants.PONT_OR_MOVE ? 'override-all' : ''}`} onClick={(event) => {
                        console.log(event.target.value);
                        props.onClick(option.value, startTime);
                        if (props.question.specs.answer.toString() === option.value.toString()) {
                            setHighlightResponse('correct');
                        }
                        else {
                            setHighlightResponse('wrong');
                        }
                        setTimeout(() => setHighlightResponse(null), 200)
                    }}>
                        <span>{option.name}</span>
                    </button>
                ))
            }
        </div>
    );
}

export default Game;